<div class="embeddedForm">
    <app-titans-form> </app-titans-form>
</div>